import React from 'react';
import { withPrefix } from 'gatsby';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown'
import { useGlobalState } from '~app/state';

const MonumentInfoStyles = styled.div`
	position: relative;
	top: -2px;
	padding: 24px;
	grid-column-start: 1;
	grid-column-end: 2;
	grid-row-end: 1;
	grid-row-end: 2;
	border: 1px solid #979797;
	background: #fff;
	overflow: -moz-scrollbars-vertical; 
	overflow-y: scroll;
	// height: calc(100vh - 347px);
	// height: calc(100vh - 325px);
	height: calc(100vh - 332px);
	z-index: 999;
	line-height: 1;
	margin-left: 24px;
	margin-right: 24px;

	.monument {
		display: none;

		&.monument-selected {
			display: block;
		}
	}

	.monument__title {
		font-family: Miller;
		margin-bottom: 12px;
		font-size: 32px;
	}

	.monument__desc {
		font-family: "Georgia";
		line-height: 1.6;
		margin-top: 16px;
		color: #212121;
		margin-bottom: 16px;

		p {
		  margin-bottom: 16px;
		}
	}

	.monument__person {
		display: none;
	}

	.monument__silhouette {
		height: 75px;
	}

	.monument__info {
		display: grid;
		grid-template-columns: auto 50%;
		grid-column-gap: 16px;
		margin-bottom: 16px;
	}

	.monument__scale {
		display: grid;
		grid-template-columns: auto 1fr;
		grid-column-gap: 8px;
	}

	.monument__materials-wrapper {
		display: grid;
		grid-template-columns: auto 1fr;
		grid-column-gap: 8px;
		font-family: Benton;
		font-size: 14px;
		line-height: 1.2;
	}

	.monument__artist {
		font-family: Miller;
		font-size: 18px;
		font-weight: 400;
		color: #212121;
		font-style: italic;
	}

	.monument__materials {
		display: grid;
		grid-row-gap: 8px;
	}

	.monument__material {
		display: grid;
		grid-template-columns: 1fr 1fr;
		// grid-column-gap: 8px;
		border: 1px solid red;
	}

	.monument__material-square {
		height: 16px;
		width: 16px;
		background: #000;
		border: 1px solid #979797;

		&.concrete {
			background: #E0E5E5;
		}

		&.metal {
			background:  #A8B0B2;
		}

		&.glass {
			background: #EBF5FB;
		}

		&.bronze {
			background: #CD7F32;
		}

		&.stone {
			background: #7F7F7F;
		}

		&.marble {
			background: #FBF7EB;
		}

		&.digital-projection {
			background: #D068F2;
		}

		&.solar-panel {
			background: #000000;
		}

		&.water {
			background: #9CD2EB;
		}

		&.fabric {
			background: #F7F4DB;
		}
	}

	.monument__size {
		font-family: Benton;
		font-size: 14px;
		line-height: 1.2;
	}

	@media (max-width: 768px) {
	  	position: relative;
 		top: -3px;
		left: 0;
		border: none;
		height: auto;
		width: 100%;
		overflow-y: initial;
		padding: 24px;
		margin-left: 0;
		margin-right: 0;
	}

	@media (max-width: 360px) {
		.monument__silhouette {
			height: auto;
			max-height: 75px;
		}
	}
`;

const MonumentInfo = ({data}) => {
	const [selectedMonument] = useGlobalState('monument');

	const monumentList = data.nodes.map((link) => {

		const monumentID = `monument monument-${link.order} ${selectedMonument === link.slug ? 'monument-selected' : ''}`;

		const monumentTitle = `${link.sculpture}`;
		const monumentTitleFull = `${link.sculptureNameLG}`;
		const monumentArtist = `${link.artist}`;
		const monumentSize = `${link.size}`;
		const monumentImage = withPrefix(`images/Size_${link.slug}.png`);
		const monumentDesc = `${link.sculptureDesc}`;

		const material1 = `${link.material1}`;
		const material2 = `${link.material2}`;
		const material3 = `${link.material3}`;

		const color1 = `monument__material-square ${link.color1}`;
		const color2 = `monument__material-square ${link.color2}`;
		const color3 = `monument__material-square ${link.color3}`;

		return (
			<div className={monumentID} key={link.slug}>
		    	<div className="monument__info">
		    		<div className="monument__scale">
		    			<img src={monumentImage} className="monument__silhouette" alt={monumentTitle} />
		    			<div className="monument__size">{monumentSize}</div>
		    		</div>

		    		<div className="monument__materials-wrapper">
		    			<p className="monument__materials-title">Materials:</p>

		    			<div className="monument__materials">
			    			<div className="monument__material">
			    				<div className={color1}></div>
			    				<p className="monument__material-name">{material1}</p>
			    			</div>

			    			<div className="monument__material">
			    				<div className={color2}></div>
			    				<p className="monument__material-name">{material2}</p>
			    			</div>

			    			<div className="monument__material">
			    				<div className={color3}></div>
			    				<p className="monument__material-name">{material3}</p>
			    			</div>
		    			</div>
		    		</div>
		    	</div>

		    	<p className="monument__title">{monumentTitle}</p>
		    	<p className="monument__artist">{monumentArtist}</p>
		    	<ReactMarkdown><div className="monument__desc">{monumentDesc}</div></ReactMarkdown>
			</div>
		);
	});

	return (
	    <MonumentInfoStyles>
	    	{monumentList}
	    </MonumentInfoStyles>
	);
};

export default MonumentInfo;
